import React, { useEffect } from "react";
import "./style.css";
import { useIntl } from "react-intl";
import ButtonCircle from "../../general/buttonCircle";
import CategoryImg from "./categories";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import LoaderSimple from "../../general/loader";
import { deleteTemplateAsk } from "../../../store/actions/ask/templates";
import { ConfirmAbortModal } from "@ts-digital/vrc";
import { displaySuccessToast } from "../../../store/actions/overflowNotification";
import { StandardTabs, Tab } from "@ts-digital/vrc";
import DownloadedTemplatesList from "../edit/dots/downloadedTemplatesList.jsx";
import { FormattedMessage } from "react-intl";
import { FEATURE_TOGGLE_DOTS } from "../../../config";
import VisibilityIconsFilter from "./dots/visibilityIconsFilter";
import {
  useModelsGeneralTemplatesFilters,
  useModelsVisibilityTemplatesFilters,
  useOrderTemplates
} from "../../../customHooks";
import CommunityTemplatesOrderSelect from "./dots/communityTemplatesOrderSelect";
import CategoriesFilters from "./categoriesFilters";

const ChooseTemplateAsk = props => {
  const {
    onSelection
  } = props;

  const intl = useIntl();
  const main = useSelector(state => state.main);
  const templates = useSelector(state => state.ask.templates.list);
  const isGettingTemplates = useSelector(state => state.ask.templates.isGettingTemplates);
  const [limitCards, setLimitCards] = useState(true);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [categories, setCategories] = useState([]);
  const [filteredTemplates, setFilteredTemplates] = useState([]);
  const [activeFilter, setActiveFilter] = useState(intl.formatMessage({ id: "all"}));
  const [isActiveOwner, setIsActiveOwner] = useState(true);
  const [isActiveClients, setIsActiveClients] = useState(true);
  const [isActiveCommunity, setIsActiveCommunity] = useState(true);
  const [, setOrderByDate] = useState(true);
  const [orderAlphabetically, setOrderAlphabetically] = useState(false);
  const [orderAlphabeticallyReverse, setOrderAlphabeticallyReverse] = useState(false);
  const dispatch = useDispatch();
  const myType = main.myType;

  const emptyMessage = useIntl().formatMessage({ id: "ask.pages.edit.chooseTemplate.empty" });
  const chooseTemplateTitle = useIntl().formatMessage({
    id: `ask.pages.edit.chooseTemplate.title${myType !== "STUDIO" ? "Company" : ""
    }`
  });
  const chooseTemplateSubtitle = useIntl().formatMessage({
    id: `ask.pages.edit.chooseTemplate.subtitle${myType !== "STUDIO" ? "Company" : ""
    }`
  });
  const moreOnOff = useIntl().formatMessage({
    id: `ask.pages.edit.chooseTemplate.${limitCards ? "moreOn" : "moreOff"
    }`
  });

  useEffect(() => {
    const availableCategories = templates?.map(templ => templ.categoryId);
    const uniqueCategories = [...new Set(availableCategories)];
    setCategories([intl.formatMessage({ id: "all"}), ...uniqueCategories]);
  }, [templates]);

  const filterCategories = (category) => {
    setActiveFilter(category);
    const filteredTemplatesList = templates?.filter(templ => {
      if (category === intl.formatMessage({ id: "all"})) {
        return templates;
      }
      return templ.categoryId === category;
    });
    setFilteredTemplates(filteredTemplatesList);
  };

  const filterByOwner = () => {
    setIsActiveOwner(!isActiveOwner);
  };

  const filterByClientsOrCommunity = (index) => {
    if (index === 1) {
      setIsActiveClients(!isActiveClients);
    } else {
      setIsActiveCommunity(!isActiveCommunity);
    }
  };

  const renderTemplateCard = (
    title, template, index
  ) => {
    return (
      <div key={`askEdit-templateCard-root${index}`} className="askEdit-templateCard-root">
        <div
          className="askEdit-templateCard-item"
          onClick={() => onSelection(template ? template.templateId : null)}
        >
          {template ? (
            <div
              style={{
                background: `url(${CategoryImg(template.categoryId)})`,
                backgroundSize: "contain"
              }}
              className="askEdit-templateCard-bg"
            >
            </div>
          ) : (
            <ButtonCircle onClick={() => onSelection()} />
          )}
        </div>
        <div className="askEdit-templateCard-title-container">
          <div className="askEdit-templateCard-title">
            {template &&
              <FontAwesomeIcon
                icon={["far", template?.availableTo === "owner" ? "lock" : "portrait"]}
                className="askEdit-templateCard-icon"
              />
            }
            {title}
          </div>
          {myType === "STUDIO" && template && (
            <Tooltip
              title={
                <div className="askEdit-templateCard-trash-container">
                  <FontAwesomeIcon
                    icon={["far", "trash-alt"]}
                    className="askEdit-templateCard-trash"
                    onClick={e => {
                      e.stopPropagation();
                      setConfirmDelete(template.templateId);
                    }}
                  />
                </div>
              }
              color={"white"}
              overlayClassName={"askEdit-templateCard-tooltip"}
            >
              <FontAwesomeIcon icon={["far", "ellipsis-v"]} className="askEdit-templateCard-ellipsis" />
            </Tooltip>
          )}
        </div>
      </div>
    );
  };

  const filteredVisibilityTemplates = useModelsVisibilityTemplatesFilters(
    templates, isActiveOwner, isActiveClients, isActiveCommunity
  );

  const templatesToIterate = useModelsGeneralTemplatesFilters(
    filteredTemplates, filteredVisibilityTemplates, templates
  );

  const orderedTemplates = useOrderTemplates(
    templatesToIterate, false, orderAlphabetically, orderAlphabeticallyReverse, "title"
  );

  const renderTemplates = () => {
    if (isGettingTemplates) {
      return <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 180,
          height: 140
        }}
      >
        <LoaderSimple />
      </div>;
    }
    return orderedTemplates.map((item, index) => {
      if (!limitCards || (limitCards && index < 9)) {
        return renderTemplateCard(
          item.title, item, index
        );
      } 
      return null;
      
    });
  };

  const handleTabChange = e => {
    setActiveTab(e);
  };

  return (
    <div className="askEdit-chooseTemplate-root">
      {confirmDelete && (
        <ConfirmAbortModal
          visible={confirmDelete}
          title={"Rimozione modello"}
          onAbort={() => setConfirmDelete(false)}
          onConfirm={() => {
            dispatch(deleteTemplateAsk(confirmDelete)).then(res => {
              setConfirmDelete(false);
              displaySuccessToast("Modello rimosso con successo", "");
            });
          }}
          abortText={"No"}
          confirmText={"Si"}
        >
          <div style={{ padding: "30px 0" }}>
            Confermi la rimozione del modello selezionato?
          </div>
        </ConfirmAbortModal>
      )}
      {FEATURE_TOGGLE_DOTS === "true" && myType === "STUDIO" && (
        <StandardTabs
          style={{ marginBottom: "5px", overflow: "hidden", width: "100%" }}
          activeIndex={activeTab}
          onChange={handleTabChange}
        >
          <Tab className="askChooseTemplateTab" key={0} style={{ width: myType !== "STUDIO" ? "100%" : "33%" }}>
            <FormattedMessage id="ask.pages.edit.chooseTemplate.yourTemplatesTab" />
          </Tab>
          <Tab className="askChooseTemplateTab" key={1}>
            <FormattedMessage id="ask.pages.edit.chooseTemplate.downloadedTemplatesTab" />
          </Tab>
          <Tab className="askChooseTemplateTab" key={2}>
            <FormattedMessage id="ask.pages.edit.chooseTemplate.toValidateTemplatesTab" />
          </Tab>
        </StandardTabs>
      )}
      {activeTab === 0 && (
        <div>
          <div className="askEdit-chooseTemplate-title-container">
            <div>
              <div
                className={`askEdit-chooseTemplate-title${myType !== "STUDIO" ? " company" : ""
                }`}
              >
                {chooseTemplateTitle}
              </div>
              <div className="askEdit-chooseTemplate-subtitle-container">
                {myType === "STUDIO" &&
                  <>
                    <div
                      className={`askEdit-chooseTemplate-subtitle${myType !== "STUDIO" ? " company" : ""
                      }`}
                    >
                      {chooseTemplateSubtitle}
                    </div>
                    {FEATURE_TOGGLE_DOTS === "true" && <div className="askEdit-chooseTemplate-filterIconContainer">
                      <VisibilityIconsFilter
                        filterByOwner={filterByOwner}
                        filterByClientsOrCommunity={filterByClientsOrCommunity}
                        isActiveOwner={isActiveOwner}
                        isActiveClients={isActiveClients}
                        isActiveCommunity={isActiveCommunity}
                      />
                    </div>}
                  </>
                }
              </div>
            </div>
            <div
              className="askEdit-chooseTemplate-cards-more"
            >
              {myType === "STUDIO" &&
                <CommunityTemplatesOrderSelect
                  setOrderByDate={setOrderByDate}
                  setOrderAlphabetically={setOrderAlphabetically}
                  setOrderAlphabeticallyReverse={setOrderAlphabeticallyReverse}
                />
              }
              <Tooltip
                title={moreOnOff}
                color={"rgb(0, 80, 117)"}
              >
                <FontAwesomeIcon
                  icon={["far", "ellipsis-h"]}
                  className="cards-more-icon"
                  onClick={() => setLimitCards(!limitCards)}
                  style={{ display: templatesToIterate.length > 9 ? "" : "none" }}
                />
              </Tooltip>
            </div>
          </div>
          <div className="askEdit-chooseTemplate-cards-container">
            <div className="askEdit-categories-container">
              <CategoriesFilters
                categories={categories}
                activeFilter={activeFilter}
                filterCategories={filterCategories}
              />
              {/* {renderCategories()} */}
            </div>
            <div className="askEdit-templates-container">
              {myType === "STUDIO" &&
                renderTemplateCard(emptyMessage)
              }
              {renderTemplates()}
            </div>
          </div>
        </div>
      )}
      {activeTab === 1 && (
        <div>
          <DownloadedTemplatesList onSelection={onSelection} />
        </div>
      )}
    </div>
  );
};

export default ChooseTemplateAsk;
